module.exports = __webpack_public_path__ + "img/icon07.893f8625.svg";